module.exports = __webpack_public_path__ + "img/UTOTTE-9.6c5993c1.jpg";